<template>
  <div>
    <div class="container ny_content">
      <div class="ny_nav">
        <div class="ny_nav_h">
          <div>
            <h2>第三方评估</h2>
            <p>THIRD PARTY ASSESSMENT</p>
          </div>
        </div>
        <div class="ny_nav_dqwz">
          当前位置：<span class="hidden-xs">服务项目></span>第三方评估
        </div>
      </div>
      <div class="ny_view">
        <div class="row">
          <p v-html="assessList.content" style="text-indent: 36px;font-size: 18px;line-height: 36px;letter-spacing: 1px;color: #000000;" class="col-md-9"></p>
          <p class="col-md-3">
            <img v-for="(i_item,i_index) in assessList.img" :key="i_index" :src="i_item.url" style="height: 240px;margin-top: -30px;">
          </p>
        </div>

        <div class="fwxm_dsf position-static" >
          <div class="ny_gsjj" >
            <h2>测评案例</h2>
            <div id="dsf_cpal">
              <div class="row">
                <div class="col-md-3 col-xs-12 dsf_cpal_cell" v-for="(c_item,c_index) in assessList.moreNotifyObject" :key="c_index">
                  <h4>{{c_item.title}}</h4>
                </div>

              </div>
            </div>
          </div>

        </div>



      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'index',
  data(){
    return {
      assessList:[]
    }
  },
  created () {
    this.getAssessList()
  },
  methods:{
    async getAssessList(){
      const {data:res} = await this.$http.get('home/assess_list')
      if (res.code !== 200) return false
      this.assessList = res.data.content
     }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/service/assessment/index.vue